interface ToCheckBannerProps {
  toCheck: boolean;
  reasons: string | null;
}

const FALLBACK_REASON = 'raison non renseignée';

/**
 * Inline "flagged for review" banner for the word detail header. Unlike
 * {@link ToCheckBadge} (list/mosaic, tooltip-gated), this shows the reason
 * text directly — a prominent banner hiding its own explanation behind hover
 * is awkward, especially on touch devices with no hover.
 */
export function ToCheckBanner({ toCheck, reasons }: ToCheckBannerProps) {
  if (!toCheck) return null;

  return (
    <output className="words-to-check-banner">
      <span className="material-symbols-rounded" aria-hidden="true">
        warning
      </span>
      <span>À vérifier — {reasons?.trim() ? reasons : FALLBACK_REASON}</span>
    </output>
  );
}
